
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"-128 0 438 438.857","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"m181.679688 186.824219c-1.707032-2.484375-4.527344-3.96875-7.535157-3.96875h-64v-173.710938c0-4.410156-3.144531-8.183593-7.472656-8.992187-4.351563-.796875-8.625 1.59375-10.207031 5.710937l-91.429688 237.710938c-1.0781248 2.8125-.703125 5.972656 1 8.457031 1.707032 2.488281 4.527344 3.96875 7.539063 3.96875h64v173.714844c0 4.40625 3.140625 8.183594 7.472656 8.992187.5625.101563 1.125.148438 1.675781.148438 3.714844 0 7.152344-2.28125 8.527344-5.859375l91.429688-237.714844c1.082031-2.8125.703124-5.972656-1-8.457031zm-89.820313 193.648437v-133.617187c0-5.046875-4.089844-9.140625-9.144531-9.140625h-59.828125l68.972656-179.332032v133.617188c0 5.046875 4.089844 9.144531 9.140625 9.144531h59.832031zm0 0"}})])
          )
        }
      }
    